import { useEffect, useState, useRef } from "react";
import { useSpeechPlayer } from "src/utils/core/hooks";

const PX_PER_SECOND = 25;

const useTTSPlayer = ({ instanceId }) => {
  const { handlePlayPause, closeSpeechPlayer, isPlaying, isLoading, text, progress, voiceName, isOpen } = useSpeechPlayer({ instanceId });
  const [shouldScroll, setShouldScroll] = useState(false);
  const [duration, setDuration] = useState(null);
  const textRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!isLoading && textRef.current && wrapperRef.current) {
      const textWidth = textRef.current.scrollWidth;
      const wrapperWidth = wrapperRef.current.clientWidth;

      const shouldScroll = textWidth > wrapperWidth;
      setShouldScroll(shouldScroll);

      if (shouldScroll) {
        const distance = textWidth + wrapperWidth;
        const duration = distance / PX_PER_SECOND;
        setDuration(`${duration}s`);
      }
    }
  }, [isLoading, text]);

  const handleClose = () => {
    closeSpeechPlayer();
  };

  return {
    textRef,
    wrapperRef,
    // state
    text,
    duration,
    shouldScroll,
    isPlaying,
    isOpen,
    isLoading,
    progress,
    voiceName,
    // handlers
    handleClose,
    handlePlayPause,
  };
};

export default useTTSPlayer;
